import { useSelector } from 'react-redux'
import { createSelector, Selector } from '@reduxjs/toolkit'
import { RootState } from '../store'
import {
  Tenant,
  TrainingEvent,
  User,
  UserRole,
} from '@alucio/aws-beacon-amplify/src/models'
import { CognitoUser } from 'src/models/User'
import {
  ORMTypes,
  TrainingEventORM,
} from 'src/types/orms'

export const selTrainingEvents = (state: RootState): TrainingEvent[] => state.trainingEvent.records
export const selTenants = (state: RootState): Tenant[] => state.tenant.records
export const selCognitoUser = (state: RootState): CognitoUser | undefined => state.user.cognitoUser;
export const selUsers = (state: RootState): User[] => state.user.records

export const trainingEventsList: Selector<RootState, TrainingEventORM[]> = createSelector(
  selTrainingEvents,
  selTenants,
  selCognitoUser,
  selUsers,
  (trainingEvents, tenants, cognitoUser, users): TrainingEventORM[] => {
    const user = users.find(({ id }) => id === cognitoUser?.attributes['custom:user_id'])

    const mapped = trainingEvents.reduce<TrainingEventORM[]>((acc, trainingEvent) => {
      const tenant = tenants.find(({ id }) => id === trainingEvent.tenantId)

      if (!tenant && user?.role !== UserRole.ALUCIO_ADMIN) {
        console.warn('Could not identify user\'s tenant')
        return acc
      }

      const ORM: TrainingEventORM = {
        model: trainingEvent,
        type: ORMTypes.TRAINING_EVENT,
      }
      acc.push(ORM)
      return acc
    }, [])
    return mapped
  },
)

export const trainingEventsByTenantId: Selector<RootState, TrainingEventORM[]> = createSelector(
  trainingEventsList,
  (_: RootState, tenantId: string | undefined) => tenantId,
  (trainingEventsList: TrainingEventORM[], tenantId): TrainingEventORM[] => tenantId ? trainingEventsList
    .filter(trainingEventORM => trainingEventORM.model.tenantId === tenantId) : [],
)

export const useTrainingEventsByTenantId = (tenantId: string): ReturnType<typeof trainingEventsByTenantId> =>
  useSelector((state: RootState) => trainingEventsByTenantId(state, tenantId))

export const useIstrainingEventHydrated = () => useSelector((state: RootState) => state.trainingEvent.hydrated)
